import React from "react";
import PropTypes from "prop-types";
import SectionHeader from "components/molecules/SectionHeader";
import StorageUnitSizeChartCard from "components/molecules/StorageUnitSizeChartCard/StorageUnitSizeChartCard";
import "./StorageUnitSizeChart.scss";
import classNames from "classnames";
import Container from "components/core/Page/Container";
import { PSPMarkdownContent } from "components/molecules";
import Section from "../../core/Page/Section";

const SECTION_HEADER_PROPS = {
	paragraph: {
		size: "standard",
		color: "darkGray",
		weight: "regular"
	}
};

const POST_MODULE_DESCRIPTION_PROPS = {
	paragraph: {
		size: "standard",
		color: "darkGray",
		weight: "regular",
		style: { padding: 0, margin: 0, marginTop: "1rem" }
	}
};

export default function StorageUnitSizeChart(props) {
	const {
		title = "",
		description = "",
		image,
		storages = [],
		background = "white",
		postModuleDescription
	} = props;

	return (
		<Section
			className={classNames(
				"storage-unit-size-chart-section",
				background
			)}
		>
			<Container>
				<SectionHeader
					title={title}
					description={description}
					contentAlign="text-center"
					additionalProps={SECTION_HEADER_PROPS}
					titleProps={{
						size: "xxlarge",
						weight: "bold",
						color: "black"
					}}
					className="storage-unit-size-chart-header"
					image={image}
					isPageContainer={false}
				/>
				<div className="storage-unit-size-cards">
					{storages.map((storage) => (
						<StorageUnitSizeChartCard
							key={storage.title}
							storage={storage}
							background={background}
						/>
					))}
				</div>
				{postModuleDescription && (
					<PSPMarkdownContent
						content={postModuleDescription}
						additionalProps={POST_MODULE_DESCRIPTION_PROPS}
					/>
				)}
			</Container>
		</Section>
	);
}

StorageUnitSizeChart.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	image: PropTypes.string,
	postModuleDescription: PropTypes.string,
	storages: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			description: PropTypes.string,
			numerics: PropTypes.arrayOf(PropTypes.string),
			bestFor: PropTypes.arrayOf(PropTypes.string)
		})
	),
	background: PropTypes.oneOf(["light-blue", "white"])
};
